import { GET_API, POST_API, PUT_API, DELETE_API, PATCH_API } from "../../Functionalities/APIs";
import { clearRestaurantCache } from "../../Functionalities/restaurantCache";
import {
  franchiseDetailsUrl,
  adminDashboardOrderSummaryUrl,
  configurationsUrl,
  configurationsParamUrl,
  branchDetailsUrl,
  accountsBranchBalanceUrl,
  accountsAllAccountsUrl,
} from "../../Constants/apiUrls";

export const ManageBlock = async (e, data, keyword, params) => {
    if (keyword == 'patch') {
        let path = franchiseDetailsUrl;
        var fdata = new FormData();
        fdata.append('keyword', "block_franchise");
        fdata.append('is_block', data.is_block);
        fdata.append('franchise_id', data.id);

        let result = PATCH_API(fdata, '', path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

}
export const ManageFranchise = async (e, data, keyword, params) => {
    // e.preventDefault()
    let path = franchiseDetailsUrl;

    if (keyword == "add") {
        var fdata = new FormData();

        fdata.append("place ", data.place);
        fdata.append("latitude ", data.latitude);
        fdata.append("longitude ", data.longitude);
        fdata.append("address ", data.address);

        fdata.append("mobile ", data.mobile);
        fdata.append("commission ", data.commission);


        fdata.append('franchise_name', data.franchise_name);
        fdata.append("description ", data.description);

        fdata.append("admin_name ", data.admin[0].admin_name);
        fdata.append("admin_username ", data.admin[0].admin_username);
        fdata.append("admin_password ", data.admin[0].admin_password);
        fdata.append("admin_mobile", data.admin[0].admin_mobile);
        fdata.append("managers_list", JSON.stringify(data.managers));
        fdata.append("restaurants_within_radius", restaurantAreaFormValue(data.restaurants_within_radius) ?? "");

        let result = POST_API(fdata, "", path);

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }

    if (keyword == "update") {
        // void 0

        var fdata = new FormData();
        fdata.append("franchise_name", data.name);
        fdata.append("franchise_id", data.id);
        fdata.append("place ", data.place);
        fdata.append("latitude ", data.latitude);
        fdata.append("longitude ", data.longitude);
        fdata.append("address ", data.address);
        fdata.append("commission ", data.commission);

        fdata.append("mobile ", data.mobile);
        fdata.append("description ", data.description);

        data.adminEdit && fdata.append("keyword", "admin_update");
        fdata.append("admin_name ", data.admin_name);
        fdata.append("admin_username ", data.admin_username);
        fdata.append("admin_password ", data.admin_password);
        fdata.append("admin_mobile", data.admin_mobile);
        const restaurantArea = restaurantAreaFormValue(data.restaurants_within_radius);
        restaurantArea !== undefined && fdata.append("restaurants_within_radius", restaurantArea);

        let result = PUT_API(fdata, "", path, '');
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });

    }
    if (keyword == "patch") {
        // alert('patched')
        // void 0

        let path = franchiseDetailsUrl;
        var fdata = new FormData();

        fdata.append("franchise_id", data.franchise_id);
        fdata.append("keyword ", "commission");
        fdata.append("commission ", data.commission);
        let result = PATCH_API(fdata, "", path);


        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
    // }

    if (keyword == "delete") {
        // alert("delete not worked");
        // return 0;
        let result = DELETE_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == "get") {
        // void 0
        let result = GET_API("", params, path);
        return await result.then((result) => {
            // void 0
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == "") {
        // alert("Invalid keyword value");
    }
};


export const OrderSummary = async (e, data, keyword, params) => {
    let path = adminDashboardOrderSummaryUrl;

    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0

        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}



export const ManageSettings = async (e, data, keyword, params) => {
    let path = configurationsUrl;
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}
export const ManageSettingsAdmin = async (e, data, keyword, params) => {
    let path = configurationsParamUrl + "?";
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageRestaurantCharge = async (e, data, keyword, params) => {
    let path = configurationsParamUrl;
    if (keyword == "get") {
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == 'add') {
        var fdata = new FormData()
        fdata.append('param_name', data.param_name);
        fdata.append('new_param_value', data.charge);
        fdata.append('keyword', data.keyword);
        fdata.append('branch_id', data.branch_id);

        let result = POST_API(fdata, '', path)
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageRestaurantImage = async (e, data, keyword, params) => {
    // void 0
    let path = branchDetailsUrl;
    if (keyword == 'patch') {
        var fdata = new FormData()
        fdata.append('keyword', 'remove_image');
        fdata.append('image_ids', JSON.stringify(data));
        let result = PATCH_API(fdata, '', path)
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageBalanceAmount = async (e, data, keyword, params) => {
    // void 0

    if (keyword == 'get') {
        let path = accountsBranchBalanceUrl;
        let result = GET_API("", params, path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == 'add') {
        let path = accountsAllAccountsUrl;

        var fdata = new FormData();
        fdata.append('branch_id', data.branch_id);
        fdata.append('amount', data.amount);
        fdata.append('mode_of_payment', data.mode_of_payment);
        fdata.append('discription', data.discription);
        let result = POST_API(fdata, '', path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                // void 0
                return result;
            } else {
                return 0;
            }
        });
    }
}

export const ManageFeatured = async (e, data, keyword, params) => {
    if (keyword == 'update') {
        let path = branchDetailsUrl;
        var fdata = new FormData();
        fdata.append('keyword', "is_featured");
        fdata.append('is_featured', data.is_featured);
        fdata.append('id', data.id);

        let result = PUT_API(fdata, '', path);
        // void 0
        return await result.then((result) => {
            // void 0
            if (result) {
                clearRestaurantCache();
                return result;
            } else {
                return 0;
            }
        });
    }

}

export const ManageMinCartValue = async (e, data, keyword, params) => {
    let path = configurationsParamUrl;
    if (keyword == "get") {
        let result = GET_API("", params, path);
        return await result.then((result) => {
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
    if (keyword == 'add') {
        let result = POST_API(data, '', path)
        return await result.then((result) => {
            if (result) {
                return result;
            } else {
                return 0;
            }
        });
    }
}

// The API sends the limit to super admins only; a page that never received it must not send it back.
export const restaurantAreaFormValue = (value) =>
  value === undefined ? undefined : value === null ? "" : String(value);
